// dependencies
import React from "react";

// styles
import css from "./NetchexButton.module.scss";

const NetchexButton = () => (
	<a href="/login/netchex-oauth/" className={`${css.main}`} aria-label="Sign in with Netchex">
		<div className={css.iconWrapper}>
			<img alt="" src="/static/img/Integrations/netchex-icon.png" />
		</div>
		<div className={css.label}>Sign in with Netchex</div>
	</a>
);

export default NetchexButton;
